import type { FieldValidator } from '@lucidtech/las-sdk-browser';
import { useCallback } from 'react';

import { useModelConfigStore } from '@/store';

export type UseFormatterMutationOpts = {
  fieldId: string;
  formatterId: string;
  parentId?: string | null;
};

export const useFormatterMutation = ({ fieldId, formatterId, parentId }: UseFormatterMutationOpts) => {
  const updateFormatter = useModelConfigStore((state) => state.updateFormatter);

  return useCallback(
    (mutateFn: (v: FieldValidator) => void) => {
      updateFormatter(
        fieldId,
        formatterId,
        (formatter) => {
          mutateFn(formatter);
          return formatter;
        },
        parentId
      );
    },
    [fieldId, formatterId, parentId, updateFormatter]
  );
};

export type UseValidatorMutationOpts = {
  fieldId: string;
  validatorId: string;
  parentId?: string | null;
};

export const useValidatorMutation = ({ fieldId, validatorId, parentId }: UseValidatorMutationOpts) => {
  const updateValidator = useModelConfigStore((state) => state.updateValidator);

  return useCallback(
    (mutateFn: (v: FieldValidator) => void) => {
      updateValidator(
        fieldId,
        validatorId,
        (validator) => {
          mutateFn(validator);
          return validator;
        },
        parentId
      );
    },
    [fieldId, validatorId, parentId, updateValidator]
  );
};
